import Vue from "vue";
import YmapPlugin from "vue-yandex-maps";

const settings = {
    apiKey: "0fe09a79-7c31-4723-9b82-6af67e4c9487",
    lang: "ru_RU",
    coordorder: "latlong",
    version: "2.1",
}; // настройки плагина

Vue.use(YmapPlugin, settings);
